import { useCallback, useEffect, useMemo, useState } from 'react'
import Footer from '../../components/Footer'
import { useTheme } from '../../context/themeContext'
import IntroductionStep from './IntroductionStep'
import ChurnReasonFlow from './ChurnReasonFlow'
import ReasonSelectionStep from './ReasonSelectionStep'
import { CHURN_REASONS } from './reasons'
import { usePostChurnDataMutation } from '../../services/churn'

export default function ChurnFlow() {
  let [at, setAt] = useState(1)
  let [selectedReasonId, setSelectedReasonId] = useState(null)
  let { theme } = useTheme()
  let { mutateAsync: postChurnData } = usePostChurnDataMutation()

  useEffect(() => {
    const root = document.documentElement
    root.classList.add('dark')
    return () => {
      if (theme !== 'dark') {
        root.classList.remove('dark')
      }
    }
  }, [theme])

  let selectedReason = useMemo(() => {
    return CHURN_REASONS.find((reason) => reason.id === selectedReasonId) || null
  }, [selectedReasonId])

  let handleComplete = useCallback(async (data) => {
    let { meta, ...rest } = data
    let payloadForServer = {
      ...rest,
      reasonId: selectedReason?.id || rest.reason,
      reasonTitle: selectedReason?.title || null,
      completedAt: new Date().toISOString(),
    }

    try {
      await postChurnData(payloadForServer)
    } catch (error) {
      console.error('Failed to send churn data', error)
    }

    if (!meta?.preventReset) {
      setSelectedReasonId(null)
      setAt(1)
    }
  }, [postChurnData, selectedReason])

  let steps = useMemo(() => [
    <IntroductionStep key='intro' onNext={() => setAt(2)} />,
    <ReasonSelectionStep
      key='reason-selection'
      reasons={CHURN_REASONS}
      selectedReasonId={selectedReasonId}
      onSelect={(id) => {
        setSelectedReasonId(id)
      }}
      onNext={() => setAt(3)}
    />,
    <ChurnReasonFlow
      key={selectedReason ? selectedReason.id : 'flow'}
      reason={selectedReason}
      onBackToReasons={() => {
        setAt(2)
      }}
      onComplete={handleComplete}
    />,
  ], [selectedReason, selectedReasonId, handleComplete])

  return (
    <div className='flex flex-col w-full h-full items-center justify-between overflow-auto select-none'>
      {steps[at - 1]}
      <Footer className='mt-6 pl-0' />
    </div>
  )
}
